/* unplugin-vue-components disabled */import { render } from "./explanation.vue?vue&type=template&id=0a3b6b91&scoped=true"
import script from "./explanation.vue?vue&type=script&lang=js"
export * from "./explanation.vue?vue&type=script&lang=js"

import "./explanation.vue?vue&type=style&index=0&id=0a3b6b91&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3b6b91"]])

export default __exports__